export default function Reviews() { return <div style={{padding:"2rem"}}><h1>Reviews</h1></div>; }